import type { RouteObject } from 'react-router-dom'

import type { NavItem } from '@/app/registry'

import { HistoryPage } from './HistoryPage'
import { SessionEditorPage } from './SessionEditorPage'
import { SessionPage } from './SessionPage'

// /workout (тренировка в зале) — отдельный тикет; здесь история, карточка и ввод задним числом.
export const routes: RouteObject[] = [
  { path: '/workouts', element: <HistoryPage /> },
  { path: '/workouts/new', element: <SessionEditorPage /> },
  { path: '/workouts/:id', element: <SessionPage /> },
  { path: '/workouts/:id/edit', element: <SessionEditorPage /> },
]

export const nav: NavItem[] = [{ path: '/workouts', label: 'История тренировок', icon: 'history', mobile: 'more', order: 40 }]
